"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getQuery;

function getQuery(_ref) {
  var query = _ref.query,
      sortedBy = _ref.sortedBy,
      sortDirection = _ref.sortDirection;

  if (typeof query === 'function') {
    if (typeof sortedBy === 'string') {
      return function (ref) {
        return query(ref).orderBy(sortedBy, sortDirection);
      };
    }

    return query;
  }

  if (typeof sortedBy === 'string') {
    return function (ref) {
      return ref.orderBy(sortedBy, sortDirection);
    };
  }

  return undefined;
}